import { get as val } from 'object-path'
import * as immu from 'object-path-immutable'
import langs from './language.json'
import { blueprint } from './questions'

// Names export
export function provider( xeon ) {

  // Filter rules for serotonerg
  const rules = Object.values( xeon.rules ).filter( rule => {
    return rule.param && rule.param.some( l => l.includes( "extra anticholinergic" ) )
  } )

  const kineticRules = Object.values( xeon.rules ).reduce( ( acc, cur ) => {
    if ( cur.group == "kinetic" ) {
      acc[ cur.drug ] = cur
    }
    return acc
  }, {} )

  return {

    // Score between 0 -100
    score: function ( scale = 2.5 ) {
      const notNegativ = Math.max( 0, this.scoring().value - 1 )
      return Math.min( 100, parseInt( notNegativ * scale ) )
    },

    // Score threshold 3 so 1 - 20
    scoring: function () {
      if ( Object.keys( xeon.drugs ).length ) {
        const danger = this.danger()

        // Do not penalize if the score is less then 3
        // Kinetic Rules can increase danger
        if ( danger < 3 ) {
          return {
            value: 1
          }
        }

        return { value: danger }
      } else {
        // If no drugs no color
        return { value: null }
      }
    },

    abstract: function ( lang ) {
      return {
        name: langs[ lang ][ "title" ],
        hash: "anticholinergic",
        ...this.scoring()
      }
    },

    drugNamesById: function ( lang ) {
      return Object.values( xeon.drugs ).reduce( ( acc, cur ) => {
        return immu.set( acc, cur.id, cur[ "name" ][ lang ] )
      }, {} )
    },


    // ---------------------------------------------------------------
    // Group drugs for subgroup
    // { mild: [], moderate: [], strong: ["linezolid"], none: [] }
    // ---------------------------------------------------------------
    subgroup: function () {
      // We need drugs to find the nones
      const stats = { strong: [], moderate: [], mild: [], insignificant: [], none: [] }

      for ( const drug of Object.values( xeon.drugs ) ) {
        // Group serotonerg has one rule per drug
        const rule = rules.filter( rule => rule.drug == drug.id ).slice( 0 ).pop()
        // Iterate subgroups even if it's just one entry to find errors
        if ( rule ) {
          if ( rule.param.some( l => l.includes( "strong" ) && l.includes( "anticholinergic" ) ) ) {
            stats[ "strong" ].push( drug.id )
          } else if ( rule.param.some( l => l.includes( "moderate" ) && l.includes( "anticholinergic" ) ) ) {
            stats[ "moderate" ].push( drug.id )
          } else if ( rule.param.some( l => l.includes( "mild" ) && l.includes( "anticholinergic" ) ) ) {
            stats[ "mild" ].push( drug.id )
          } else if ( rule.param.some( l => l.includes( "insignificant" ) && l.includes( "anticholinergic" ) ) ) {
            stats[ "insignificant" ].push( drug.id )
          } else if ( rule.param.some( l => l.includes( "none" ) && l.includes( "anticholinergic" ) ) ) {
            stats[ "none" ].push( drug.id )
          } else {
            const line = rule.param.filter( l => l.includes( "anticholinergic" ) ).pop()
            console.log( "Questions for anticholinergic has unknown param", line )
          }
        }
        if ( !rule ) {
          stats.none.push( drug.id )
        }
      }

      return stats
    },

    // ---------------------------------------------------------------
    // Danger drug score based on subgroup
    // info starting at 3
    // ---------------------------------------------------------------
    danger: function () {

      const crits = this.subgroup()
      var score = 0

      // five milds equals to 5
      if ( crits.mild.length > 0 ) {
        score += drugRiskPoints( crits.mild, 1, kineticRules )
      }
      // two moderate equals 4
      if ( crits.moderate.length > 0 ) {
        score += drugRiskPoints( crits.moderate, 2, kineticRules )
      }
      // one strong equals 3
      if ( crits.strong.length > 0 ) {
        score += drugRiskPoints( crits.strong, 3, kineticRules )
      }

      return score
    },

    // ---------------------------------------------------------------
    // Answers
    // { yes:[], no: ["kognitiv.tremor"], unknown: [], missing: [] }
    // ---------------------------------------------------------------
    answers: function () {

      const { faqs: {} } = xeon

      const stats = {
        yes: [],
        no: [],
        unknown: [],
        missing: []
      }

      for ( const id of Object.keys( blueprint ) ) {
        for ( const key of Object.keys( blueprint[ id ] ) ) {
          // Dont add to missing if the question has not been prepared
          if ( !faqs[ id ] ) {
            continue
          }
          if ( !faqs[ id ][ key ] || !faqs[ id ][ key ].length ) {
            stats.missing.push( `${id}.${key}` )
          } else {
            if ( faqs[ id ][ key ] == "yes" ) stats.yes.push( `${id}.${key}` )
            if ( faqs[ id ][ key ] == "no" ) stats.no.push( `${id}.${key}` )
            if ( faqs[ id ][ key ] == "unknown" ) stats.unknown.push( `${id}.${key}` )
          }
        }
      }

      return stats
    }

  }

}

const drugRiskPoints = function ( drugs, factor, kineticRules ) {
  return drugs.reduce( ( acc, drugId ) => {
    let scale = 1
    if ( typeof kineticRules[ drugId ] != "undefined" ) {
      if ( kineticRules[ drugId ].predict && kineticRules[ drugId ].predict.net_effect == '+' ) {
        scale = 2
      } else if ( kineticRules[ drugId ].predict && kineticRules[ drugId ].predict.net_effect == '++' ) {
        scale = 3
      }
    }
    acc += factor * scale
    return acc
  }, 0 )
}